import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'searchbar',
  templateUrl: './searchbar.component.html',
  styleUrl: './searchbar.component.css'
})
export class SearchbarComponent implements OnChanges {
  @Input() states: any = { advancedOpen: false };
  @Input() LOCALIZATION!: any;
  @Input() user!: any;
  @Input() userPermissions!: any;
  @Input() searchResults!: any;
  @Input() mapViewEnabled!: boolean;
  @Input() mapDetached!: boolean;
  @Input() simpleview!: any;
  @Input() streamingQueries!: any;
  @Input() isMoreLikeThisEnabled!: boolean;
  @Input() recordsMgmtServicesEnabled!: boolean;
  @Input() viewerMode!: string;

  @Input() simpleSearch!: (event?: KeyboardEvent) => void;
  @Input() removeFacet!: (key: string) => void;
  @Input() toggleAdvanced!: () => void;
  @Input() doCleanSearches!: () => void;
  @Input() saveSearch!: () => void;
  @Input() changeView!: (view: string, dropdown?: NgbDropdown) => void;
  @Input() newSearch!: () => void;
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['userPermissions'] && changes['userPermissions'].currentValue) {
      console.log('User permissions received in child:', this.userPermissions);
    }
  }
}
